var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('strong',{staticStyle:{"text-decoration":"none"}},[_c('span',{staticStyle:{"padding":"5px 10px","font-weight":"300","border-radius":"4px"},style:({ 'background-color': _vm.bgColor, color: _vm.color })},[_vm._t("default")],2)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6e2666d6","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/orderStatusBgColor/orderStatusBgColor.vue
// module id = null
// module chunks = 